import * as React from 'react'

import { styled } from '@mui/material/styles'
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded'
import CardActionArea from '@mui/material/CardActionArea'
import Stack from '@mui/material/Stack'
import Card from '@mui/material/Card'

import Text from 'components/atomic/atoms/text'
import Chip from 'components/atomic/atoms/chip'
import Link from 'next/link'
import Routes from 'utils/routes'
import { Box } from '@mui/material'

const StyledCard = styled(Card)`
    height: 100%;
    box-shadow: none;
`

const CardContent = styled('div')`
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 1rem;
    justify-content: space-between;
    z-index: 1;
    top: 0;
    left: 0;
    padding: 1rem;
`

interface RoleCardProps {
    item: {
        _id: string
        slug: string
        title: string
        salary: string
        categoriesTitles: string[]
    }
}

const RoleCard = React.memo(({ item }: RoleCardProps) => {
    return (
        <Link href={Routes.WikiRole(item.slug)}>
            <a>
                <StyledCard>
                    <CardActionArea sx={{ height: '100%' }}>
                        <CardContent>
                            <Stack height={'100%'} spacing={2}>
                                <Stack
                                    direction={'row'}
                                    justifyContent={'space-between'}
                                    alignItems={'center'}
                                    spacing={2}>
                                    <Text variant="h6" flexGrow={1} overflow="ellipsis">
                                        {item.title}
                                    </Text>
                                    <Text variant="caption" sx={{ display: 'flex', alignItems: 'center' }}>
                                        <AttachMoneyRoundedIcon color="primary" fontSize="small" /> {item.salary}
                                    </Text>
                                </Stack>
                                <Box display="flex" flexWrap="wrap" gap={1}>
                                    {item.categoriesTitles.slice(0, 3).map((category, index) => (
                                        <Chip
                                            variant="outlined"
                                            size="small"
                                            sx={{ color: 'text.secondary' }}
                                            label={category}
                                            key={index}
                                        />
                                    ))}
                                </Box>
                            </Stack>
                        </CardContent>
                    </CardActionArea>
                </StyledCard>
            </a>
        </Link>
    )
})

export default RoleCard
